import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SidebarComponent } from './component/sidebar/sidebar.component';
import { TabbarComponent } from './component/tabbar/tabbar.component';
import { HomeComponent } from './pages/home/home.component';



const routes: Routes = [
  // {
  //   path: '', component: SidebarComponent,
  //   children:[
  //     {path: '', component: TabbarComponent,
  //       children:[
  //         {path:'',component: HomeComponent},
  //         {path:'home',component: HomeComponent},
  //       ]
  //     }
  //   ]
  // },
  // {path:'login',component:LoginComponent},
  // {path:'register',component: RegisterComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class TestWeiyunRoutingModule { }
